const track_checkout = true;
const forceSubdomain = null;
const persistentParams = ["ttclid", "utm_campaign", "utm_medium", "utm_source", "sdp", "domain"];

(function storeInitialQueryParams() {
  const urlParams = new URLSearchParams(window.location.search);
  persistentParams.forEach(param => {
    const value = urlParams.get(param);
    if (value) {
      document.cookie = `${param}=${value}; path=/; max-age=2592000`; // 30 jours
    }
  });
})();

function getCookieValue(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

function injectPersistentParamsInUrl() {
  const url = new URL(window.location.href);
  let modified = false;

  persistentParams.forEach(param => {
    if (!url.searchParams.has(param)) {
      const value = getCookieValue(param);
      if (value) {
        url.searchParams.set(param, value);
        modified = true;
      }
    }
  });

  if (modified) {
    window.history.replaceState(null, "", url.toString());
  }
}

['pushState', 'replaceState'].forEach(method => {
  const original = history[method];
  history[method] = function (...args) {
    original.apply(this, args);
    window.dispatchEvent(new Event('urlchange'));
  };
});

window.addEventListener('popstate', () => {
  window.dispatchEvent(new Event('urlchange'));
});

window.addEventListener('urlchange', injectPersistentParamsInUrl);
injectPersistentParamsInUrl();

const iframePixel = document.createElement('div');
iframePixel.id = 'iframePixel';
iframePixel.style.display = 'none';
document.body.insertBefore(iframePixel, document.body.firstChild);

function generateSecretKey() {
  const secretArray = { 0: "Q", 1: "M", 2: "Z", 3: "L", 4: "T", 5: "X", 6: "N", 7: "V", 8: "R", 9: "K" };
  const getRandomLetters = (length) => {
    const letters = 'QMZLTXNVRK';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += letters[Math.floor(Math.random() * letters.length)];
    }
    return result;
  };
  const timestampStr = String(Math.floor(Date.now() / 1000));
  let secret = '';
  for (let i = 0; i < timestampStr.length; i++) {
    const char = timestampStr[i];
    secret += secretArray[char] || '?';
  }
  const prefix = getRandomLetters(10);
  const suffix = getRandomLetters(10);
  return `${prefix}-${secret}-${suffix}`;
}

function getPersistentParamsForIframe() {
  const urlParams = new URLSearchParams(window.location.search);
  const collected = {};

  persistentParams.forEach(param => {
    const value = urlParams.get(param);
    if (value) {
      collected[param] = value;
    }
  });

  return collected;
}

function buildTrackingIframeSrc(baseUrl, additionalParams = {}) {
  const allParams = {
    ...getPersistentParamsForIframe(),
    ...additionalParams,
    s: generateSecretKey()
  };
  const query = new URLSearchParams(allParams).toString();
  return `${baseUrl}?${query}`;
}

const subdomainPixel = getCookieValue('sdp');
const baseDomain = getCookieValue('domain');
const custom_domain_pixel = subdomainPixel ? subdomainPixel+"."+baseDomain: null;

if (subdomainPixel) {
  const domainPixel = forceSubdomain ? `${forceSubdomain}.${baseDomain}` : `${subdomainPixel}.${baseDomain}`;
  const iframePageView = document.createElement('iframe');
  iframePageView.src = buildTrackingIframeSrc(`https://${domainPixel}/`, { action: "PageView" });
  iframePageView.style.width = "1px";
  iframePageView.style.height = "1px";
  iframePageView.style.border = "0";
  iframePageView.referrerPolicy = "no-referrer";
  iframePageView.id = "iframePixelPageView";
  document.getElementById("iframePixel").appendChild(iframePageView);

  window.QPActionATC = function (variantId, productName, productHandle, productPrice, shopCurrency) {
    const iframeAddToCart = document.createElement('iframe');
    iframeAddToCart.src = buildTrackingIframeSrc(`https://${domainPixel}/`, { action: "AddToCart", price: productPrice, currency: shopCurrency, variant_id: variantId });
    iframeAddToCart.style.width = "1px";
    iframeAddToCart.style.height = "1px";
    iframeAddToCart.style.border = "0";
    iframeAddToCart.referrerPolicy = "no-referrer";
    iframeAddToCart.id = "iframePixelAddToCart";
    document.getElementById("iframePixel").appendChild(iframeAddToCart);
  };
}
